
/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import {generateUUID} from "./lib/uuid";

class Encryption {
    pendingRequests = {}
    ready = false;
    initialized = false;

    constructor() {
    }

    setup(){
        if(this.initialized){
           return
        }


        this.initialized = true
        this.worker = new Worker("/workers/encryption.js")
        this.worker.onmessage = ($event) =>{
            let data = $event.data
            let requestID = data?.requestID
            if(!requestID){
                if(data.initialized){
                    this.ready = true
                }
                return
            }

            let resolveReject = this.pendingRequests[requestID]
            if(!resolveReject){return;}
            delete this.pendingRequests[requestID]
            let [resolve, reject] = resolveReject
            if(data.success){
                resolve(data.response)
            } else {
                reject(data.response)
            }
        }

        this.checkIfReady().finally()
    }

    async checkIfReady(){
        this.request("isReady", [], false).then((result)=>{
            if(result.response && !this.ready){
                this.ready = true
            }

            return result.response
        })
    }

    async request(name, args = [], wait = true){
        this.setup()
        let evID = `encryption.${name}.${generateUUID()}`
        let promise = new Promise((resolve, reject) =>{
            this.pendingRequests[evID] = [resolve, reject]
        })

        if(wait){
            await this.whenReady()
        }


        this.worker.postMessage({
            fn: name,
            requestID: evID,
            args: args
        })

        return promise
    }

    encrypt(data, armour){
        return this.request("dreamEncrypt", [data, armour])
    }

    decrypt(data, armour){
        return this.request("dreamDecrypt", [data, armour])
    }

    keyGen(){
        return this.request("dreamGen", [])
    }

    waitForKey(){
        return new Promise(async (resolve, reject) => {
            const key = 'e2e'
            await this.whenReady()
            let raw = localStorage.getItem(key) || '{}'
            let info = {}
            try{
                info = JSON.parse(raw)
            }catch (e){
                console.error(e)
                reject({"error": e})
                return
            }

            if(this.inValidEncryptionInfo(info)) {
                info = await this.keyGen()
                if(this.validEncryptionInfo(info)){
                    try{
                        localStorage.setItem(key, JSON.stringify(info))
                    }catch (e){
                        console.error(e)
                        reject({"error": e})
                        return
                    }
                }
            }

            resolve(info)
        })
    }

    whenReady(){
        return new Promise((resolve)=>{
            if(this.ready){
                resolve(true)
                return
            }

            let interval;

            interval = setInterval(()=>{
                if(this.ready){
                    clearInterval(interval)
                    resolve(true)
                }
                this.checkIfReady().finally()
            }, 100)
        })
    }

    inValidEncryptionInfo(info) {
        return !info || !(info?.priv && info?.pub)
    }
    validEncryptionInfo(info){return !this.inValidEncryptionInfo(info)}
}

let EncryptionSVC = new Encryption()

const waitForDream = async ()=>{
    return EncryptionSVC.whenReady()
}

const waitForPGPKey = ()=>{
    return EncryptionSVC.waitForKey()
}

window.waitForDream = waitForDream

export {waitForDream, waitForPGPKey, EncryptionSVC}
